import { People } from '@material-ui/icons';

import List from './List';

export default {
  list: List,
  icon: People,
};
